























import terms from '@/assets/agreements/terms.html';
import RichTextDisplay from '@/components/common/RichTextDisplay.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    RichTextDisplay,
  },
})
export default class Terms extends Vue {
  public termsText: string = terms;
}
